import { createDeleteTeamOptions } from 'modals/modal-options-factory';
import { useDispatch } from 'react-redux';
import { toggleModal } from 'state/callers';

const useDeleteTeamModal = () => {
  const dispatch = useDispatch();

  const trigger = async ({
    title = 'Confirmation',
    confirmText = 'Yes',
    cancelText = 'Cancel',
    width,
    accountsNames,
    teamName,
    type,
    extraText
  } = {}) => {
    return new Promise(resolve => {
      const deleteModalOptions = createDeleteTeamOptions({
        title,
        confirmText,
        cancelText,
        width,
        accountsNames,
        teamName,
        onConfirm: () => {
          toggleModal()(dispatch);
          resolve(true);
        },
        onCancel: () => {
          toggleModal()(dispatch);
          resolve(false);
        },
        type,
        extraText
      });

      toggleModal(deleteModalOptions)(dispatch);
    });
  };

  return trigger;
};

export default useDeleteTeamModal;
